// src/components/NotificationModal/ChangeLogItem.tsx
import React from "react";
import { ChangeLogEntry } from "./NotificationModal";
import { IsUnreadTr, Td } from "./styles";

interface ChangeLogItemProps {
    log: ChangeLogEntry;
    isExpanded: boolean;
    onToggle: () => void;
    formatDateTime: (date: string) => string;
    onRead: (id: number) => void;
    isAllChangesUnread: boolean;
}

const ChangeLogItem: React.FC<ChangeLogItemProps> = ({
    log,
    isExpanded,
    onToggle,
    formatDateTime,
    onRead,
    isAllChangesUnread,
}) => {
    const isUnread = !log.is_read && isAllChangesUnread;

    return (
        <React.Fragment>
            <IsUnreadTr
                onClick={() => {
                    onToggle();
                    if (isUnread) {
                        onRead(log.id);
                    }
                }}
                style={{ cursor: "pointer", userSelect: "none" }}
                $isUnread={isUnread}
            >
                <Td style={{ whiteSpace: "nowrap" }}>
                    {formatDateTime(log.created_at)}
                </Td>
                <Td>{log.action_by}</Td>
                <Td>{log.action}</Td>
                <Td>{log.group_name}</Td>
            </IsUnreadTr>

            {isExpanded && (
                <tr>
                    <td
                        colSpan={4}
                        style={{
                            padding: "12px 0 12px 30px",
                            fontSize: "0.95em",
                            color: "#555",
                            maxWidth: "100%",
                        }}
                    >
                        <div style={{ display: "grid", gap: "6px" }}>
                            <code
                                style={{
                                    background: "#f4f4f4",
                                    padding: "6px 8px",
                                    borderRadius: "4px",
                                    display: "inline-block",
                                    fontFamily: "monospace",
                                    wordBreak: "break-all",
                                    whiteSpace: "pre-wrap",
                                    maxWidth: "100%",
                                    maxHeight: "200px",
                                    overflowY: "scroll",
                                }}
                            >
                                {log.meta.before
                                    ? JSON.stringify(log.meta.before, null, 2)
                                    : "null"}{" "}
                                →{" "}
                                {log.meta.after
                                    ? JSON.stringify(log.meta.after, null, 2)
                                    : "null"}
                            </code>
                        </div>
                    </td>
                </tr>
            )}
        </React.Fragment>
    );
};

export default ChangeLogItem;
